document.addEventListener("DOMContentLoaded", () => {
    const storeData = {
        'hamburg': {
            name: 'Hamburg',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_hamburg-eimsbuettel_2000x1400_f11345f0-d056-451e-aef1-acb6893ad67f.jpg?v=1688641907&width=1800',
            phone: '+49 (0) 40 70 97 92 00',
            email: 'hamburg@kandderstadt.com',
            address: 'Eppendorfer Weg 54 | 20259 Hamburg-Eimsbüttel',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Hamburg+Eppendorfer+Weg+54'
        },
        'bremen': {
            name: 'Bremen',
            img: 'https://kandderstadt.com/cdn/shop/files/hero-teaser_kindderstadt-bremen-aussen_2000x1400_d30d933c-cc72-416b-a4db-6fc333ad2e60.jpg?v=1729843415&width=1800',
            phone: '+49 (0) 421 - 22 38 68 86',
            email: 'bremen@kandderstadt.com',
            address: 'Violenstr. 33 | 28195 Bremen',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Bremen+Violenstr+33'
        },
        'hannover': {
            name: 'Hannover',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_hannover-kinderzimmer_2000x1400_eee064ca-a79f-4b07-b24c-fa55431df526.jpg?v=1688643890&width=1800',
            phone: '+49 (0) 511 - 390 62 502',
            email: 'hannover@kandderstadt.com',
            address: 'Podbielskistr. 10 | 30163 Hannover',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Hannover+Podbielskistr+10'
        },
        'muenster': {
            name: 'Münster',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-muenster_2000x1400_d4b394c4-1a64-43dd-a7eb-3b0d2884974c.jpg?v=1760171108&width=1800',
            phone: '+49 (0) 251 - 84 93 23 21',
            email: 'muenster@kandderstadt.com',
            address: 'Bergstraße 71-72 | 48143 Münster',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Muenster+Bergstrasse+71'
        },
        'bocholt': {
            name: 'Bocholt',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-bocholt_2000x1400_c56d2e19-0fd4-49fd-9c27-3066cac3dfd2.jpg?v=1688670938&width=1800',
            phone: '+49 (0) 2871 - 29 27 793',
            email: 'bocholt@kandderstadt.com',
            address: 'Nordstr. 31 | 46399 Bocholt',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Bocholt+Nordstr+31'
        },
        'regensburg': {
            name: 'Regensburg',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-regensburg-2000x1400.jpg?v=1688645236&width=1800',
            phone: '+49 (0) 941 83 09 73 10',
            email: 'regensburg@kandderstadt.com',
            address: 'Baumhackergasse 1 | 93047 Regensburg',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Regensburg+Baumhackergasse+1'
        },
        'dortmund': {
            name: 'Dortmund',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-dortmund_2000x1400_b3b0647d-5c4b-4c37-8593-445bf6aa5188.jpg?v=1688670710&width=1800',
            phone: '+49 (0) 231 - 77571109',
            email: 'dortmund@kandderstadt.com',
            address: 'Kaiserstraße 70 | 44135 Dortmund',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Dortmund+Kaiserstrasse+70'
        },
        'heidelberg': {
            name: 'Heidelberg',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-heidelberg-5_2000x1400_58eeb943-c704-4447-8055-75f0325516d1.jpg?v=1709234856&width=1800',
            phone: '+49 (0) 6221 65 44 490',
            email: 'heidelberg@kandderstadt.com',
            address: 'Schillerstrasse 32 | 69115 Heidelberg',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Heidelberg+Schillerstrasse+32'
        },
        'frankfurt': {
            name: 'Frankfurt am Main',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-hello-little-one_2000x1400_1a41b05b-0c33-4a29-96d3-9dc757ac5a74.jpg?v=1699885330&width=1800',
            phone: '+49 (0) 69 - 84 84 58 04',
            email: 'frankfurt@kandderstadt.com',
            address: 'Oeder Weg 43 | 60318 Frankfurt am Main',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Frankfurt+Oeder+Weg+43'
        },
        'oldenburg': {
            name: 'Oldenburg',
            img: 'https://kandderstadt.com/cdn/shop/files/teaser_kds-oldenburg-aussenansicht_2000x1400_fd907bf6-504c-4845-979c-4d3dcd656c2e.jpg?v=1759752834&width=1800',
            phone: '+49 (0) 441 99 86 86 60',
            email: 'oldenburg@kandderstadt.com',
            address: 'Alexanderstraße 19a | 26121 Oldenburg',
            maps: 'https://www.google.com/maps/search/?api=1&query=KIND+DER+STADT+Oldenburg+Alexanderstrasse+19a'
        }
    };

    function getURLParameter(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    const cityParam = getURLParameter('city');
    if (!cityParam) return;

    const cityKey = cityParam.toLowerCase();
    const currentPath = window.location.pathname;
    const isClosed = localStorage.getItem(`popup_closed_${cityKey}`);

    if (storeData[cityKey] && !isClosed && !currentPath.includes(`/pages/kind-der-stadt-${cityKey}`)) {
        const data = storeData[cityKey];
        const popupOverlay = document.querySelector('.popup-overlay');
        const popup = document.querySelector('.popup');
        const popupContent = document.querySelector('.popup-content');
        const cleanPhone = data.phone.replace(/[\s()\-]/g, '');

        // Hier wird nun der Link um die Adresse gelegt
        popupContent.innerHTML = `
            <button class="popup-close" aria-label="Schließen">&times;</button>
            <img src="${data.img}" alt="KIND DER STADT ${data.name}" class="popup-store-img">
            <h3 style="margin:0 0 10px 0; color:white; font-size: 1.2em;">Besuche uns in ${data.name}!</h3>
            <p class="popup-text">Lass dich vor Ort persönlich beraten und entdecke unsere Auswahl.</p>
            
            <div class="popup-contact-info" style="text-align: left; margin-bottom: 20px; font-size: 0.9em; line-height: 1.6;">
                <div style="margin-bottom: 8px;">
                    <a href="tel:${cleanPhone}" style="color: white; text-decoration: none; display: flex; align-items: center; gap: 8px;">
                        <span>📞</span> <strong>${data.phone}</strong>
                    </a>
                </div>
                <div style="margin-bottom: 8px;">
                    <a href="mailto:${data.email}" style="color: white; text-decoration: none; display: flex; align-items: center; gap: 8px;">
                        <span>✉️</span> ${data.email}
                    </a>
                </div>
                <div>
                    <a href="${data.maps}" target="_blank" style="color: white; text-decoration: none; display: flex; align-items: flex-start; gap: 8px;">
                        <span style="flex-shrink: 0;">📍</span> <span>${data.address}</span>
                    </a>
                </div>
            </div>

            <a href="/pages/kind-der-stadt-${cityKey}" class="popup-link popup-link-store">Zum Store & Terminbuchung</a>
        `;

        // Kleiner Delay (1 Sekunde), damit die Seite erst laden kann
        setTimeout(() => {
            popupOverlay.style.display = 'block';
            popup.style.display = 'block';
        }, 1000);

        const closePopup = () => {
            popupOverlay.style.display = 'none';
            popup.style.display = 'none';
            localStorage.setItem(`popup_closed_${cityKey}`, 'true');
        };

        document.querySelector('.popup-close').addEventListener('click', closePopup);
        popupOverlay.addEventListener('click', closePopup);
    }
});